import { spaces } from '../../settings';
import styled from 'styled-components';
import { ResponsiveProp, resolveResponsiveProp } from '../../lib/responsiveProps';
import { joinAndFilter } from '../../lib/joinAndFilter';

export interface InlineProps {
    space: ResponsiveProp<spaces.Space>;
    noWrap?: boolean;
}

export const Inline = styled.div<InlineProps>`
    display: inline-flex;
    align-items: center;
    flex-wrap: ${({ noWrap = false }) => (noWrap ? 'nowrap' : 'wrap')};

    ${({ space }) => {
        return joinAndFilter(
            resolveResponsiveProp(space, 'margin-top', spaces.negativeSizes),
            resolveResponsiveProp(space, 'margin-left', spaces.negativeSizes)
        );
    }}

    > * {
        ${({ space }) => {
            return joinAndFilter(
                resolveResponsiveProp(space, 'margin-top', spaces.sizes),
                resolveResponsiveProp(space, 'margin-left', spaces.sizes)
            );
        }}
    }
`;
